import {
    observable,
    computed
} from 'mobx';

// 底部

const initial = {
    list: [{
            id: 1,
            title: "react",
            url: "https://reactjs.org/"
        },
        {
            id: 2,
            title: "mobx",
            url: "https://mobx.js.org/"
        },
        {
            id: 3,
            title: "material-ui",
            url: "https://material-ui.com/"
        },
        {
            id: 4,
            title: "axios",
            url: "https://github.com/axios/axios"
        },
        {
            id: 5,
            title: "webpack",
            url: "https://webpack.js.org/"
        },
        {
            id: 6,
            title: "babel",
            url: "http://babeljs.io/"
        }]
}

export default class Foot {
    @observable datas = initial;

    @computed get year() {
        return (new Date()).getFullYear();
    }
}